import React from 'react';
import {
  formatCurrency,
  FORMAT_CURRENCY_INCOME_COLOR,
  FORMAT_CURRENCY_EXPENSE_COLOR,
} from '../../utils/dateUtils';

export type MoneyType = 'income' | 'expense' | 'neutral';

const TYPE_COLOR: Record<MoneyType, string | undefined> = {
  income: FORMAT_CURRENCY_INCOME_COLOR,
  expense: FORMAT_CURRENCY_EXPENSE_COLOR,
  neutral: undefined,
};

export type MoneyProps = Omit<React.HTMLAttributes<HTMLSpanElement>, 'children'> & {
  value: number | null | undefined;
  type: MoneyType;
};

/**
 * Единое отображение суммы: `formatCurrency` + цвет по типу (доход / расход / нейтрально).
 */
export const Money: React.FC<MoneyProps> = ({ value, type, className, style, ...rest }) => {
  const n = value == null || Number.isNaN(Number(value)) ? 0 : Number(value);
  const color = TYPE_COLOR[type];
  return (
    <span
      className={className}
      style={color != null ? { color, ...style } : { ...style }}
      {...rest}
    >
      {formatCurrency(n)}
    </span>
  );
};

export default Money;
